export enum WarehousePageEnum {
  WAREHOUSES = "Warehouses",
  STORAGE_BOXES = "Storage boxes",
  STORAGE_BOX_TYPES = "Storage box types",
}